import HidingContext from '@/context/HideContext';
import { FC, useContext, useEffect } from 'react';


interface IHiddenProps {
    hide: boolean;
}

const Hidden: FC<IHiddenProps> = ({
    hide
}) => {

    const { setHiding } = useContext(HidingContext);

    useEffect(() => {
        setTimeout(() => setHiding(hide), 0)
    }, [setHiding, hide]);

    return null;
}

export default Hidden